// Translation for nl
export const nl = {
        common: {
            save: 'Opslaan',
            cancel: 'Annuleren',
            close: 'Sluiten',
            delete: 'Verwijderen',
            edit: 'Bewerken',
            activate: 'Activeren',
            add: 'Toevoegen',
            saving: 'Opslaan...',
            loading: 'Laden...',
            active: 'ACTIEF',
            inUse: 'In Gebruik',
            test: 'Test',
            searchApps: 'Apps zoeken...',
            betaBanner: 'BETA - Service nog niet beschikbaar!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Aanmelden',
            signUp: 'Registreren',
            username: 'Gebruikersnaam',
            password: 'Wachtwoord',
            continue: 'Doorgaan',
            noAccount: 'Nog geen account?',
            hasAccount: 'Heb je al een account?',
            loginError: 'Aanmelden mislukt',
            invalidCredentials: 'Ongeldige gebruikersnaam of wachtwoord',
            rateLimited: 'Te veel aanmeldpogingen. Wacht alstublieft even.',
            sessionExpired: 'Je sessie is verlopen. Gebruik alstublieft een nieuwe magische link.',
            magicLinkInvalid: 'De aanmeldlink is ongeldig of verlopen.',
            magicLinkSuccess: 'Welkom! Je bent succesvol aangemeld.',
            magicLinkProcessing: 'Aanmelding verwerken...',
            connectionError: 'Verbindingsfout. Probeer opnieuw.'
        },
        profile: {
            myProgress: 'Mijn Leervoortgang',
            signOut: 'Afmelden',
            plan: 'Plan: '
        },
        settings: {
            title: 'Instellingen',
            tabs: {
                uiSettings: 'UI-instellingen',
                systemPrompt: 'Systeemprompt',
                llmProfiles: 'LLM-profielen',
                ttsProfiles: 'TTS-profielen',
                language: 'Taal',
            },
            uiSettings: {
                title: 'Gebruikersinterface',
                themeMode: 'Themamodus',
                darkMode: 'Donkere Modus',
                lightMode: 'Lichte Modus',
                themeColor: 'Themkleur',
                themeColorDesc: 'Kies de accentkleur voor knoppen, pictogrammen en markeringen',
                background: 'Achtergrond',
                backgroundDesc: 'Kies een achtergrond voor je werkplek',
                selectBackgroundColor: 'Selecteer Achtergrondkleur',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Concentratie',
                    concentration: 'Aandacht',
                    relaxation: 'Ontspanning',
                    lianas: 'Lianen',
                    color: 'Kleur'
                },
                backgroundColors: {
                    deepDark: 'Diep Zwart',
                    darkGrey: 'Donkergrijs',
                    midnightBlue: 'Middernachtblauw',
                    indigo: 'Indigo',
                    darkTeal: 'Donker Tealblauw',
                    brown: 'Bruin',
                    darkRed: 'Donkerrood',
                    deepPurple: 'Diep Paars',
                    pureWhite: 'Zuiver Wit',
                    softWhite: 'Zacht Wit',
                    lightGrey: 'Lichtgrijs',
                    paleBlue: 'Bleek Blauw',
                    paleGreen: 'Bleek Groen',
                    paleOrange: 'Bleek Oranje',
                    lavender: 'Lavendel',
                    blueGrey: 'Blauwgrijs'
                }
            },
            systemPrompt: {
                label: 'Systeemprompt:',
                placeholder: 'Systeemprompt laden...',
                emptyError: 'Systeemprompt mag niet leeg zijn!',
                saveSuccess: '✓ Systeemprompt succesvol opgeslagen!',
                loadError: 'Fout bij laden van systeemprompt',
                saveError: 'Fout bij opslaan'
            },
            llmProfiles: {
                addButton: '+ Nieuwe Verbinding Toevoegen',
                newConnection: 'Nieuwe Verbinding',
                editConnection: 'Verbinding Bewerken',
                emptyState: 'Geen LLM-verbindingen beschikbaar. Klik hieronder om er een toe te voegen.',
                loadingProfiles: 'Profielen laden...',
                nameLabel: 'Naam *',
                namePlaceholder: 'bijv. OpenAI GPT-4',
                apiUrlLabel: 'API-URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API-sleutel *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, enz.',
                allFieldsRequired: 'Alle velden moeten ingevuld zijn!',
                saveSuccess: '✓ Profiel succesvol opgeslagen!',
                deleteConfirm: 'Wil je "{name}" echt verwijderen?',
                profileNotFound: 'Profiel niet gevonden!',
                loadError: 'Fout bij laden van profielen',
                saveError: 'Fout bij opslaan',
                activateError: 'Fout bij activeren',
                deleteError: 'Fout bij verwijderen',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Nieuwe Stem Toevoegen',
                newVoice: 'Nieuwe Stem',
                editVoice: 'Stem Bewerken',
                emptyState: 'Geen TTS-profielen beschikbaar. Klik hieronder om er een toe te voegen.',
                loadingProfiles: 'TTS-profielen laden...',
                nameLabel: 'Naam',
                namePlaceholder: 'bijv. Mijn ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'bijv. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Lokaal)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API-URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API-sleutel *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model-ID *',
                modelIdPlaceholder: 'bijv. eleven_monolingual_v1',
                voiceIdLabel: 'Stem-ID',
                voiceIdPlaceholder: 'bijv. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Alle velden moeten ingevuld zijn!',
                saveSuccess: '✓ TTS-profiel succesvol opgeslagen!',
                deleteConfirm: 'Wil je "{name}" echt verwijderen?',
                loadError: 'Fout bij laden van TTS-profielen',
                saveError: 'Fout bij opslaan',
                activateError: 'Fout bij activeren',
                deleteError: 'Fout bij verwijderen'
            },
            language: {
                title: 'Kies Taal',
                description: 'Selecteer je voorkeurstaal voor de gebruikersinterface'
            },
        },
        chat: {
            ready: 'Gereed',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Klik START voor real-time gesprek.',
            listening: 'Luisteren...',
            speaking: 'Thorsten spreekt...',
            userLabel: 'Jij',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Voer een bericht in...',
            send: 'Verzenden',
            loginRequired: 'Meld je aan om deze service te gebruiken.',
            loginButton: 'Nu Aanmelden',
            magicLinkRequired: 'Gebruik alstublieft een magische link om aan te melden.',
            creditLimitError: 'Je uurtarief is verbruikt. Upgrade je plan (Medium/Premium) om door te gaan.',
            serviceDisabled: 'De chatservice is momenteel niet beschikbaar. Probeer het later opnieuw.'
        },
        notifications: {
            error: 'Fout',
            success: 'Succes',
            info: 'Informatie',
            unknownError: 'Een onbekende fout is opgetreden'
        },
        cookie: {
            message: 'Deze website maakt gebruik van cookies om je de beste gebruikerservaring te bieden.',
            accept: 'Accepteren'
        },
        curriculum: {
                buttonLabel: 'Curriculum',
                buttonTitle: 'Toon curriculum inhoud',
                modalTitle: '{app} Curriculum',
                sections: {
                    topic: 'Curriculum onderwerp',
                    explanation: 'Kindvriendelijke uitleg',
                    studentProfile: 'Leerlingprofiel'
                },
                topic: {
                    empty: 'Er is geen curriculum onderwerp gekoppeld aan deze micro-app in de backend.',
                    missingDetail: 'Gedetailleerde curriculum gegevens voor deze micro-app zijn nog niet beschikbaar in de backend.',
                    learningGoals: 'Leerdoelen',
                    prerequisites: 'Vereiste voorkennis',
                    unitLabel: 'Eenheid',
                    durationLabel: 'Duur',
                    difficultyLabel: 'Moeilijkheidsgraad',
                    hours: 'uur',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Geen kindvriendelijke uitleg beschikbaar.',
                    loadingPrepare: 'AI bereidt de uitleg voor',
                    loadingExplain: 'AI legt het onderwerp uit in kindvriendelijke taal',
                    requestFailed: 'Kindvriendelijke uitleg kon niet worden gegenereerd.'
                },
                studentProfile: {
                    country: 'Land',
                    region: 'Staat / Regio',
                    schoolType: 'Schooltype',
                    grade: 'Groep',
                    noContext: 'Geen leerlingcontext beschikbaar.',
                    childProfileNotFound: 'Er is geen leerlingprofiel gevonden in de backend voor de huidige aanmelding.',
                    loginProfileIncomplete: 'Het aanmeldingsprofiel bevat nog geen volledige leerlingcontext.',
                    educationContextNotFound: 'Er is een leerlingprofiel gevonden, maar er is geen curriculumtoewijzing ingesteld.',
                    noToken: 'Geen aangemelde leerling gevonden.'
                },
                errors: {
                    signInRequired: 'Log in om het curriculum te bekijken.',
                    appIdMissing: 'App-ID ontbreekt.',
                    loadFailed: 'Curriculum gegevens konden niet worden geladen.'
                }
            }
    };
